import { RangeData } from './rangeDataTypes';

const defaultState: RangeData = {};

export default defaultState;
